import React from 'react';

import './AboutUs.css'; // Assume your CSS file is named AboutUs.css

const AboutUs = () => {
  

  return (
  
      <section id="about" class="about-section1">
    <div class="container">
        <div class="about-header">
            <h2>QUI SOMMES-NOUS ?</h2>
        
        </div>
        <div class="about-content">
            <p>Chez Glowy, nous croyons que la beauté naît de l’intérieur et se reflète dans chaque éclat naturel. </p>
            <p>Nous sommes une marque de produits de beauté bio, dédiée à révéler votre lumière intérieure avec des soins respectueux de la peau et de l’environnement. Chaque formule est soigneusement pensée pour nourrir, revitaliser et sublimer votre beauté naturelle, en harmonie avec la nature.</p>
            <p>Nos produits sont conçus pour ceux qui osent briller sans compromis, en offrant des soins puissants, simples et 100% naturels. Nous avons créé Glowy pour que chaque personne puisse vivre un moment de bien-être authentique, à chaque application.</p>
            <p>Rejoignez-nous dans ce voyage vers une beauté éclatante, naturelle et sans artifice. Parce que vous méritez de briller, naturellement.</p>
            <h3>Notre Engagement</h3>
            <p>Chez Glowy, nous créons des soins bio, 100% naturels, pour respecter pleinement votre peau. 
                Nos produits sont conçus avec des ingrédients de qualité, pour vous offrir une beauté saine et respectueuse. Nous croyons en la transparence et l'authenticité à chaque application.

                Glowy incarne une beauté éthique, durable et authentique.</p>
        </div>
    </div>
</section>
  );
};

export default AboutUs;
